import { render, staticRenderFns } from "./SummaryTab2.vue?vue&type=template&id=7b27239b&scoped=true&lang=pug&"
import script from "./SummaryTab2.vue?vue&type=script&lang=js&"
export * from "./SummaryTab2.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTab2.vue?vue&type=style&index=0&id=7b27239b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b27239b",
  null
  
)

export default component.exports